(function () {
  let closeDrawer = null;
  let closeSubmenus = null;

  function initNavDrawer() {
    const drawer = document.getElementById('mobile-nav');
    const overlay = document.querySelector('.nav-overlay');
    const hamburger = document.querySelector('.header__hamburger');

    if (!drawer || !overlay || !hamburger) return;

    gsap.set(drawer, { xPercent: -100 });

    function open() {
      const tl = gsap.timeline();
      tl.to(drawer, {
        xPercent: 0,
        duration: 0.6,
        ease: 'power2.out',
      }).to(
        overlay,
        {
          opacity: 1,
          pointerEvents: 'auto',
          duration: 0.4,
        },
        '<',
      );
      hamburger.setAttribute('aria-expanded', 'true');
      hamburger.classList.add('open');
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('menu-open');
    }

    function close() {
      const tl = gsap.timeline();
      tl.to(drawer, {
        xPercent: -100,
        duration: 0.6,
        ease: 'power2.out',
      }).to(
        overlay,
        {
          opacity: 1,
          pointerEvents: 'auto',
          duration: 0.4,
        },
        '<',
      );
      hamburger.setAttribute('aria-expanded', 'false');
      hamburger.classList.remove('open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('menu-open');
      closeSubmenus?.();
    }

    closeDrawer = close;

    hamburger.addEventListener('click', () => {
      hamburger.getAttribute('aria-expanded') === 'true' ? close() : open();
    });

    overlay.addEventListener('click', close);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && hamburger.getAttribute('aria-expanded') === 'true') close();
    });

    drawer.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', close);
    });
  }

  function initSubmenus() {
    const items = Array.from(document.querySelectorAll('.nav-drawer__item--has-children'));

    closeSubmenus = () => {
      items.forEach((item) => {
        const toggle = item.querySelector('.nav-drawer__toggle');
        const sublist = item.querySelector('.nav-drawer__sublist');
        if (!sublist) return;
        gsap.to(sublist, { autoAlpha: 0, duration: 0.2, ease: 'power2.out' });
        toggle?.setAttribute('aria-expanded', 'false');
        item.classList.remove('open');
      });
    };

    function closeItem(item) {
      const toggle = item.querySelector('.nav-drawer__toggle');
      const sublist = item.querySelector('.nav-drawer__sublist');
      if (!sublist) return;
      gsap.to(sublist, { autoAlpha: 0, duration: 0.4, ease: 'power2.out' });
      toggle?.setAttribute('aria-expanded', 'false');
      item.classList.remove('open');
    }

    items.forEach((item) => {
      const toggle = item.querySelector('.nav-drawer__toggle');
      const sublist = item.querySelector('.nav-drawer__sublist');
      if (!toggle || !sublist) return;

      gsap.set(sublist, { autoAlpha: 0 });

      toggle.addEventListener('click', () => {
        const isOpen = toggle.getAttribute('aria-expanded') === 'true';

        if (isOpen) {
          closeItem(item);
        } else {
          items.filter((other) => other !== item).forEach(closeItem);

          gsap.to(sublist, { autoAlpha: 1, duration: 0.4, ease: 'power2.out' });
          toggle.setAttribute('aria-expanded', 'true');
          item.classList.add('open');
        }
      });
    });
  }

  initNavDrawer();
  initSubmenus();

  if (typeof barba !== 'undefined') {
    barba.hooks.beforeLeave(() => closeDrawer?.());
    barba.hooks.afterEnter(() => {
      initNavDrawer();
      initSubmenus();
    });
  }
})();
